export const DEFAULT_FEMALE_AVATAR_PATH = '/uploads/avatar/uzman-merve.svg';

export const DEFAULT_FEMALE_AVATAR_SVG_RAW = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 800' width='800' height='800'>
  <defs>
    <!-- Background Luxury Clinic Interior -->
    <linearGradient id='fWallGrad' x1='0%' y1='0%' x2='100%' y2='100%'>
      <stop offset='0%' stop-color='#fff1f2'/>
      <stop offset='40%' stop-color='#ffe4e6'/>
      <stop offset='70%' stop-color='#fecdd3'/>
      <stop offset='100%' stop-color='#fda4af'/>
    </linearGradient>

    <!-- Warm Sunlight Radiance -->
    <radialGradient id='fSunGlow' cx='20%' cy='15%' r='85%'>
      <stop offset='0%' stop-color='#ffffff' stop-opacity='0.95'/>
      <stop offset='30%' stop-color='#ffe4e6' stop-opacity='0.5'/>
      <stop offset='70%' stop-color='#fff1f2' stop-opacity='0.15'/>
      <stop offset='100%' stop-color='#ffffff' stop-opacity='0'/>
    </radialGradient>

    <!-- Female Skin Shading -->
    <linearGradient id='fSkinBase' x1='30%' y1='10%' x2='70%' y2='90%'>
      <stop offset='0%' stop-color='#fff1eb'/>
      <stop offset='35%' stop-color='#fed7aa'/>
      <stop offset='75%' stop-color='#fdba74'/>
      <stop offset='100%' stop-color='#fb923c'/>
    </linearGradient>

    <radialGradient id='fCheekGlow' cx='50%' cy='50%' r='50%'>
      <stop offset='0%' stop-color='#fb7185' stop-opacity='0.35'/>
      <stop offset='100%' stop-color='#fb7185' stop-opacity='0'/>
    </radialGradient>

    <!-- Medical Uniform: Deep Rose / Wine Velvet Scrubs -->
    <linearGradient id='fScrubFabric' x1='0%' y1='0%' x2='100%' y2='100%'>
      <stop offset='0%' stop-color='#881337'/>
      <stop offset='40%' stop-color='#4c0519'/>
      <stop offset='100%' stop-color='#1f030b'/>
    </linearGradient>

    <!-- Hair Shading (Rich Dark Chestnut / Espresso) -->
    <linearGradient id='fHairGrad' x1='0%' y1='0%' x2='100%' y2='100%'>
      <stop offset='0%' stop-color='#3e1d13'/>
      <stop offset='45%' stop-color='#271109'/>
      <stop offset='100%' stop-color='#120603'/>
    </linearGradient>

    <radialGradient id='fIrisGrad' cx='40%' cy='35%' r='65%'>
      <stop offset='0%' stop-color='#78350f'/>
      <stop offset='50%' stop-color='#451a03'/>
      <stop offset='100%' stop-color='#0f0401'/>
    </radialGradient>

    <filter id='fPortraitShadow' x='-10%' y='-10%' width='120%' height='120%'>
      <feDropShadow dx='0' dy='10' stdDeviation='14' flood-color='#4c0519' flood-opacity='0.22'/>
    </filter>

    <filter id='fBokehBlur' x='-20%' y='-20%' width='140%' height='140%'>
      <feGaussianBlur stdDeviation='7'/>
    </filter>
  </defs>

  <!-- Clinic Background -->
  <rect width='800' height='800' fill='url(#fWallGrad)'/>
  <rect width='800' height='800' fill='url(#fSunGlow)'/>

  <!-- Soft Clinic Foliage & Orchids -->
  <g filter='url(#fBokehBlur)' opacity='0.7'>
    <circle cx='80' cy='120' r='100' fill='#047857'/>
    <circle cx='150' cy='80' r='85' fill='#10b981'/>
    <circle cx='60' cy='250' r='90' fill='#059669'/>
    <circle cx='720' cy='140' r='110' fill='#047857'/>
    <circle cx='660' cy='80' r='90' fill='#10b981'/>
    <circle cx='750' cy='260' r='95' fill='#059669'/>
    <!-- Soft Pink Orchids -->
    <circle cx='720' cy='620' r='35' fill='#f43f5e' opacity='0.85'/>
    <circle cx='680' cy='650' r='30' fill='#fda4af' opacity='0.9'/>
    <circle cx='745' cy='670' r='32' fill='#fff1f2' opacity='0.95'/>
  </g>

  <!-- Portrait: Female Specialist -->
  <g filter='url(#fPortraitShadow)'>
    
    <!-- Torso & Medical Scrubs Uniform -->
    <path d='M100 800 C100 630 190 540 290 525 L350 600 L450 600 L510 525 C610 540 700 630 700 800 Z' fill='url(#fScrubFabric)'/>
    
    <!-- V-Neck Detail -->
    <path d='M350 525 L400 620 L450 525 Z' fill='#350714'/>
    <path d='M340 525 L400 630 L395 635 L335 530 Z' fill='#881337' opacity='0.75'/>
    <path d='M460 525 L400 630 L405 635 L465 530 Z' fill='#4c0519' opacity='0.75'/>

    <!-- Specialist Clinic Badge on Left Lapel -->
    <rect x='520' y='620' width='60' height='26' rx='6' fill='#ffffff' stroke='#f43f5e' stroke-width='1.5'/>
    <circle cx='532' cy='633' r='5' fill='#e11d48'/>
    <rect x='542' y='630' width='30' height='3' rx='1.5' fill='#881337'/>
    <rect x='542' y='635' width='22' height='2.5' rx='1' fill='#fda4af'/>

    <!-- Neck & Décolletage -->
    <path d='M345 440 L345 560 C345 590 455 590 455 560 L455 440 Z' fill='url(#fSkinBase)'/>
    <!-- Delicate Collarbone Highlight & Depth -->
    <path d='M365 555 Q400 575 435 555' stroke='#c2410c' stroke-width='2' fill='none' opacity='0.25'/>

    <!-- Ears -->
    <ellipse cx='265' cy='360' rx='20' ry='30' fill='#fed7aa'/>
    <ellipse cx='535' cy='360' rx='20' ry='30' fill='#fed7aa'/>
    <!-- Pearl Earrings -->
    <circle cx='265' cy='382' r='6' fill='#ffffff'/>
    <circle cx='264' cy='380' r='2' fill='#ffe4e6'/>
    <circle cx='535' cy='382' r='6' fill='#ffffff'/>
    <circle cx='534' cy='380' r='2' fill='#ffe4e6'/>

    <!-- Back Hair Volume / Elegant Chignon Bun -->
    <g fill='url(#fHairGrad)'>
      <circle cx='400' cy='220' r='145'/>
      <circle cx='310' cy='280' r='75'/>
      <circle cx='490' cy='280' r='75'/>
      <!-- Top Bun -->
      <circle cx='400' cy='135' r='85'/>
      <circle cx='370' cy='125' r='60'/>
      <circle cx='430' cy='125' r='60'/>
    </g>

    <!-- Face Shape: Soft Oval Aesthetic Contours -->
    <path d='M285 320 C285 220 335 170 400 170 C465 170 515 220 515 320 C515 425 465 490 400 490 C335 490 285 425 285 320 Z' fill='url(#fSkinBase)'/>

    <!-- Forehead Glow -->
    <ellipse cx='400' cy='245' rx='85' ry='50' fill='#ffffff' opacity='0.35'/>

    <!-- Cheeks Soft Rosy Glow -->
    <circle cx='335' cy='365' r='45' fill='url(#fCheekGlow)'/>
    <circle cx='465' cy='365' r='45' fill='url(#fCheekGlow)'/>

    <!-- Front Framing Hair (Silky Side Bangs & Strands) -->
    <g fill='url(#fHairGrad)'>
      <path d='M280 260 C290 190 350 170 400 170 C450 170 510 190 520 260 C490 200 440 210 400 215 C360 210 310 200 280 260 Z'/>
      <!-- Soft strand left -->
      <path d='M285 260 Q305 340 300 400 Q290 340 280 290 Z'/>
      <!-- Soft strand right -->
      <path d='M515 260 Q495 340 500 400 Q510 340 520 290 Z'/>
    </g>

    <!-- Nose -->
    <path d='M396 270 L394 365 L406 365 L404 270 Z' fill='#ea580c' opacity='0.18'/>
    <ellipse cx='400' cy='365' rx='11' ry='7' fill='#fed7aa'/>
    <ellipse cx='389' cy='370' rx='4.5' ry='3' fill='#c2410c' opacity='0.4'/>
    <ellipse cx='411' cy='370' rx='4.5' ry='3' fill='#c2410c' opacity='0.4'/>

    <!-- Lips: Soft Satin Rose Lip Glow -->
    <path d='M365 415 Q400 408 435 415 Q400 435 365 415 Z' fill='#e11d48' opacity='0.85'/>
    <path d='M370 417 Q400 422 430 417 Q400 430 370 417 Z' fill='#be123c'/>
    <!-- Radiant Lip Specular -->
    <ellipse cx='400' cy='420' rx='8' ry='2' fill='#ffffff' opacity='0.6'/>

    <!-- Eyebrows: Soft Elegantly Arched -->
    <path d='M320 280 Q350 265 378 280' stroke='#271109' stroke-width='4.5' stroke-linecap='round' fill='none'/>
    <path d='M422 280 Q450 265 480 280' stroke='#271109' stroke-width='4.5' stroke-linecap='round' fill='none'/>

    <!-- Eyes: Large, Friendly, Warm Amber-Brown with Specular Highlights -->
    <!-- Left Eye -->
    <ellipse cx='348' cy='302' rx='19' ry='12' fill='#ffffff'/>
    <circle cx='349' cy='302' r='9' fill='url(#fIrisGrad)'/>
    <circle cx='349' cy='302' r='4.5' fill='#000000'/>
    <circle cx='352' cy='299' r='3' fill='#ffffff'/>
    <circle cx='345' cy='305' r='1.5' fill='#ffffff' opacity='0.7'/>
    <path d='M328 300 Q348 290 368 300' stroke='#1c0803' stroke-width='3' stroke-linecap='round' fill='none'/>
    <!-- Eyelashes -->
    <path d='M364 296 L369 292' stroke='#1c0803' stroke-width='2' stroke-linecap='round'/>
    <path d='M358 293 L361 288' stroke='#1c0803' stroke-width='2' stroke-linecap='round'/>

    <!-- Right Eye -->
    <ellipse cx='452' cy='302' rx='19' ry='12' fill='#ffffff'/>
    <circle cx='451' cy='302' r='9' fill='url(#fIrisGrad)'/>
    <circle cx='451' cy='302' r='4.5' fill='#000000'/>
    <circle cx='454' cy='299' r='3' fill='#ffffff'/>
    <circle cx='447' cy='305' r='1.5' fill='#ffffff' opacity='0.7'/>
    <path d='M432 300 Q452 290 472 300' stroke='#1c0803' stroke-width='3' stroke-linecap='round' fill='none'/>
    <!-- Eyelashes -->
    <path d='M468 296 L473 292' stroke='#1c0803' stroke-width='2' stroke-linecap='round'/>
    <path d='M462 293 L465 288' stroke='#1c0803' stroke-width='2' stroke-linecap='round'/>

  </g>
</svg>`;

export const DEFAULT_FEMALE_AVATAR_SVG_DATA_URI =
  'data:image/svg+xml;base64,' +
  (typeof btoa !== 'undefined'
    ? btoa(DEFAULT_FEMALE_AVATAR_SVG_RAW)
    : Buffer.from(DEFAULT_FEMALE_AVATAR_SVG_RAW).toString('base64'));
